import { CartAddEvent } from '@theme/events';

const popup = document.getElementById('ComplementaryProductsPopup');
if (popup) {
  const products = popup.querySelector('[data-cpp-products]');
  const status = popup.querySelector('[data-cpp-status]');
  let requestNumber = 0;
  let previousFocus;
  let oldOverflow;
  let pendingAdds = 0;
  const drawer = () => document.querySelector('cart-drawer-component');
  const openDefaultCart = () => {
    const cartDrawer = drawer();
    if (cartDrawer?.hasAttribute('auto-open')) cartDrawer.open();
  };
  const closePopup = () => {
    // Keep feedback visible until an accessory request has completed.
    if (!pendingAdds && popup.open) popup.close();
  };

  popup.addEventListener('close', () => {
    if (oldOverflow !== undefined) document.body.style.overflow = oldOverflow;
    oldOverflow = undefined;
    if (previousFocus?.isConnected) previousFocus.focus();
  });
  popup.addEventListener('cancel', (event) => {
    if (pendingAdds) event.preventDefault();
  });
  popup.addEventListener('click', (event) => {
    if (event.target.closest('[data-cpp-close]')) closePopup();
    if (event.target === popup) {
      const box = popup.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closePopup();
    }
    if (event.target.closest('[data-cpp-cart]')) {
      if (pendingAdds) { event.preventDefault(); return; }
      const cartDrawer = drawer();
      if (cartDrawer) {
        event.preventDefault();
        closePopup();
        cartDrawer.open();
      }
    }
  });
  popup.addEventListener('change', (event) => {
    if (event.target.matches('select[name="id"]')) {
      const card = event.target.closest('[data-cpp-card]');
      const option = event.target.selectedOptions[0];
      card.querySelector('[data-cpp-price]').textContent = option.dataset.price;
      const image = card.querySelector('img.cpp__image');
      if (image && option.dataset.imageUrl) {
        // Clear the original responsive sources so the browser uses the
        // newly selected variant image instead of a cached product source.
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = option.dataset.imageUrl;
        image.alt = option.dataset.imageAlt || '';
      }
    }
  });

  async function showRecommendations(productId, number) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 5000);
    try {
      const url = new URL(popup.dataset.recommendationsUrl, location.origin);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('intent', 'complementary');
      url.searchParams.set('limit', '10');
      url.searchParams.set('section_id', 'complementary-popup-products');
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Recommendations unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const results = html.querySelector('[data-cpp-results]');
      if (number !== requestNumber) return;
      if (!results?.querySelector('[data-cpp-card]')) { openDefaultCart(); return; }

      // Close the theme cart drawer before showing the native modal.
      drawer()?.close();
      const quickAdd = document.querySelector('quick-add-dialog');
      if (typeof quickAdd?.closeDialog === 'function') quickAdd.closeDialog();
      products.replaceChildren(...results.children);
      status.textContent = '';
      if (!popup.open) {
        previousFocus = document.activeElement;
        oldOverflow = document.body.style.overflow;
        popup.showModal();
        document.body.style.overflow = 'hidden';
      }
    } catch (error) {
      if (number === requestNumber) openDefaultCart();
    } finally {
      clearTimeout(timer);
    }
  }

  // Capture marks the event before the theme drawer's bubbling listener.
  // All theme listeners still receive the original cart data and sections.
  document.addEventListener(CartAddEvent.eventName, (event) => {
    const data = event.detail?.data;
    if (data?.source === 'complementary-products-popup') {
      event.complementaryPopupHandled = true;
      return;
    }
    if (data?.source !== 'product-form-component' || data.didError || !data.productId) return;
    event.complementaryPopupHandled = true;
    void showRecommendations(String(data.productId), ++requestNumber);
  }, { capture: true });

  popup.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cpp-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const errorBox = form.querySelector('[data-cpp-error]');
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    errorBox.hidden = true;
    pendingAdds++;
    try {
      const formData = new FormData(form);
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map((element) => element.dataset.sectionId).filter(Boolean))].slice(0, 5);
      if (sectionIds.length) formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', location.pathname);
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      document.dispatchEvent(new CartAddEvent(result, String(formData.get('id')), {
        source: 'complementary-products-popup',
        itemCount: 1,
        sections: result.sections,
      }));
      button.textContent = 'Added ✓';
    } catch (error) {
      errorBox.textContent = error.message || 'Unable to add this item. Please try again.';
      errorBox.hidden = false;
      button.textContent = originalLabel;
    } finally {
      pendingAdds--;
      button.disabled = false;
    }
  });
}
